export interface KeyedTimers {
    schedule: (key: string, delayMs: number, callback: () => void) => void;
    clear: (key: string) => void;
    clearAll: () => void;
}

export function createKeyedTimers(): KeyedTimers {
    const timers = new Map<string, ReturnType<typeof setTimeout>>();

    function clear(key: string) {
        const timer = timers.get(key);
        if (timer !== undefined) {
            clearTimeout(timer);
            timers.delete(key);
        }
    }

    function schedule(key: string, delayMs: number, callback: () => void) {
        clear(key);
        const timer = setTimeout(() => {
            timers.delete(key);
            callback();
        }, delayMs);
        timers.set(key, timer);
    }

    function clearAll() {
        timers.forEach(timer => clearTimeout(timer));
        timers.clear();
    }

    return { schedule, clear, clearAll };
}
